
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vSwz", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $gdv5Z = parcelRequire("gdv5Z");

const $85a675280bdd34e2$var$styles = {
    dateWrapper: "_2rkolb4i _1h6d1j28"
};
const $85a675280bdd34e2$export$19285a5b05c4ea7c = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { timestamp: timestamp } = t0;
    let t1;
    if ($[0] !== timestamp) {
        t1 = new Date(parseInt(timestamp)).toLocaleString("en-US", {
            timeZone: "Australia/Sydney"
        });
        $[0] = timestamp;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            backgroundColor: "color.background.neutral",
            padding: "space.025",
            testId: "data-component",
            xcss: $85a675280bdd34e2$var$styles.dateWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedDate), {
            value: t1,
            year: "numeric",
            month: "short",
            day: "numeric"
        }));
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
module.exports["DateComponent"] = $85a675280bdd34e2$export$19285a5b05c4ea7c;

});


//# sourceMappingURL=DateComponent.e7d87a1b.js.map
